export const USER_PROGRESS = {
  CARD_PAYMENT: {
    CUSTOMER_TIP: {
      title: 'Customer Entering Tip on {AMOUNT}',
      index: 1,
    },
    PAYING_CARD: {
      title: 'Customer Paying {AMOUNT} With Card',
      index: 2,
    },
    AUTHORIZED_CARD: {
      title: 'Card Authorized for {AMOUNT}',
      index: 2,
    },
    PAYMENT_FINISHED: {
      VIEWING_RECEIPT: {
        title: 'Customer Viewing Receipt',
        index: 3,
        flow: 'VIEWING_RECEIPT',
      },
      TRANSACTION_COMPLETE: {
        title: 'Transaction Complete',
        index: 4,
        flow: 'TRANSACTION_COMPLETE',
      },
    },
    ERROR: {
      title: 'Card Reader Status',
      subTitle: `Card Declined\nError Code:`,
    },
  },
  RICH_CHECKOUT: {
    CUSTOMER_SCANNING: {
      index: 1,
      title: 'Customer Scanning QR to Pay {AMOUNT}',
    },
    CUSTOMER_PAYING: {
      index: 2,
      title: 'Customer Paying {AMOUNT} on Phone',
    },
    PAYMENT_FINISHED: {
      VIEWING_RECEIPT: {
        title: 'Customer Viewing Receipt',
        index: 2,
      },
      TRANSACTION_COMPLETE: {
        title: 'Transaction Complete',
        index: 3,
      },
    },
  },
}

export const CFD_POS_PAYMENT_FLOWS = {
  UNSET: 'UNSET',
  CUSTOM_TENDER: 'CUSTOM_TENDER',
  SPLIT_PAY: 'SPLIT_PAY',
  AUTO_SPLIT: 'AUTO_SPLIT', // this occur when the customer pays with a max fixed custom tender that auto splits.
  // This can also apply for ticket, qr, or gift card payments with the same circumstances above.
  QR_PAY: 'QR_PAY',
  TICKET: 'TICKET',
  GIFT_CARD: 'GIFT_CARD',
  CREDIT_CARD_AUTHORIZATION: 'CREDIT_CARD_AUTHORIZATION',
}

export const CFD_EVENTS = {
  IDLE: 'IDLE',
  CUSTOMER_WAITING_FOR_ATTENDANT: 'CUSTOMER_WAITING_FOR_ATTENDANT',
  CUSTOMER_DONE_WITH_RECEIPT: 'CUSTOMER_DONE_WITH_RECEIPT',
  CC_PAYMENT_COMPLETE: 'CC_PAYMENT_COMPLETE',
}
